import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const DISMISS_KEY = 'bragsheet_trial_ended_banner_dismissed';

// Persistent reminder shown after a user's 30-day Pro trial has expired
// and they've been moved to the Free plan. Dismissible per session — they
// see it again on next session until they upgrade.
export default function TrialEndedBanner() {
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(DISMISS_KEY) === 'true'
  );

  if (dismissed) return null;

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, 'true');
    setDismissed(true);
  };

  return (
    <div role="status" aria-live="polite" style={{
      backgroundColor: '#f1f5f9',
      borderBottom: '1px solid #cbd5e1',
      padding: '0.6rem 1.5rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.75rem',
      fontSize: '0.875rem',
      color: '#475569',
      flexWrap: 'wrap',
    }}>
      <span>
        <strong>Your Pro trial has ended.</strong> You're on the Free plan — your entries are safe. Upgrade anytime to bring back AI Tools.
      </span>
      <Link to="/pricing" style={{
        color: '#01696F',
        fontWeight: '700',
        textDecoration: 'underline',
        fontSize: '0.875rem',
        whiteSpace: 'nowrap',
      }}>
        Upgrade to Pro
      </Link>
      <button
        onClick={handleDismiss}
        aria-label="Dismiss trial-ended banner"
        style={{
          background: 'none', border: 'none', cursor: 'pointer',
          color: '#475569', fontSize: '1.1rem', padding: '0 0.25rem',
          lineHeight: 1, marginLeft: '0.25rem', opacity: 0.6,
        }}
      >
        ×
      </button>
    </div>
  );
}
